import { useState } from 'react';
import { User } from '../App';
import ClientSidebar from './ClientSidebar';
import ClientOverview from './client/ClientOverview';
import SalesInvoices from './client/SalesInvoices';
import SalesDebitNotes from './client/SalesDebitNotes';
import SalesCreditNotes from './client/SalesCreditNotes';
import PurchaseInvoices from './client/PurchaseInvoices';
import PurchaseDebitNotes from './client/PurchaseDebitNotes';
import PurchaseCreditNotes from './client/PurchaseCreditNotes';
import ReportsSection from './client/ReportsSection';
import AuditMonitoring from './client/AuditMonitoring';
import ClientSettings from './client/ClientSettings';
import { TRN } from '../types';

interface ClientDashboardProps {
  user: User;
  onLogout: () => void;
  trns: TRN[];
  onTRNBranchSwitch: (trnId: string, branchId: string) => void;
}

export type ClientView = 
  | 'overview'
  | 'sales-invoices'
  | 'sales-debit-notes'
  | 'sales-credit-notes'
  | 'purchase-invoices'
  | 'purchase-debit-notes'
  | 'purchase-credit-notes'
  | 'reports'
  | 'audit'
  | 'settings';

export default function ClientDashboard({ user, onLogout, trns, onTRNBranchSwitch }: ClientDashboardProps) {
  const [currentView, setCurrentView] = useState<ClientView>('overview');

  const renderContent = () => {
    switch (currentView) {
      case 'overview':
        return <ClientOverview />;
      case 'sales-invoices':
        return <SalesInvoices />;
      case 'sales-debit-notes':
        return <SalesDebitNotes />;
      case 'sales-credit-notes':
        return <SalesCreditNotes />;
      case 'purchase-invoices':
        return <PurchaseInvoices />;
      case 'purchase-debit-notes':
        return <PurchaseDebitNotes />;
      case 'purchase-credit-notes':
        return <PurchaseCreditNotes />;
      case 'reports':
        return <ReportsSection />;
      case 'audit':
        return <AuditMonitoring />;
      case 'settings':
        return <ClientSettings />;
      default:
        return <ClientOverview />;
    }
  };

  return (
    <div className="flex h-screen bg-[#F4F5F7]">
      <ClientSidebar
        user={user}
        currentView={currentView}
        onViewChange={setCurrentView}
        onLogout={onLogout}
        trns={trns}
        onTRNBranchSwitch={onTRNBranchSwitch}
      />
      <main className="flex-1 overflow-y-auto">
        {renderContent()}
      </main>
    </div>
  );
}
